import { CheckCircle2, FolderOpen, Trash2 } from 'lucide-react'

interface GuidedTourCompleteDialogProps {
  busy: boolean
  onKeep: () => void
  onDelete: () => void
}

export function GuidedTourCompleteDialog({ busy, onKeep, onDelete }: GuidedTourCompleteDialogProps) {
  return (
    <div className="modal-backdrop">
      <section className="modal tour-complete-dialog" role="dialog" aria-modal="true" aria-labelledby="tour-complete-title">
        <span className="tour-complete-icon"><CheckCircle2 size={27} /></span>
        <span className="modal-kicker">Guided tour complete</span>
        <h2 id="tour-complete-title">You built a two-card deck</h2>
        <p>You created a template, connected it to a variable, filled two card rows, and checked the result in Render.</p>
        <div className="tour-complete-actions">
          <button className="button secondary" disabled={busy} onClick={onDelete}><Trash2 size={16} /> Delete practice project</button>
          <button className="button primary" disabled={busy} onClick={onKeep}><FolderOpen size={16} /> Keep project</button>
        </div>
      </section>
    </div>
  )
}
